import { Outlet, useParams } from "react-router-dom";
import PropertiesPage from "../../../modules/property/PropertiesPage";

const Tab5 = ({ routeBase = "/customer/properties", mode }) => {
  const { Id } = useParams();

  return Id ? <Outlet /> : <PropertiesPage routeBase={routeBase} mode={mode} />;
};

export default Tab5;
